/**
 * CPF ou CNPJ sem máscara, como a API espera. Mantém letras: o CNPJ alfanumérico (Receita Federal, a partir de
 * 07-2026) tem letras maiúsculas nas 12 primeiras posições.
 */
export const cleanDocument = (value: string): string => (value ?? '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

/** Máscara de CPF (até 11 caracteres) ou de CNPJ, numérico ou alfanumérico (acima de 11). */
export const formatDocument = (value: string): string => {
    const document = cleanDocument(value).slice(0, 14)
    if (document.length <= 11) {
        return document
            .replace(/^(\d{3})(\d)/, '$1.$2')
            .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1-$2')
    }
    return document
        .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
        .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
        .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
        .replace(/([A-Z0-9]{4})([A-Z0-9])/, '$1-$2')
}
